<template>
    <div class="list" v-bind:class="enableListScroll(comment.answerList.length)">
        <div v-for="answer in comment.answerList">
            <!-- Answer -->
            <div v-show="!answer.hidden">
                <!-- Compact view -->
                <div v-show="!answer.showExpanded" class="listAnswerContent" v-bind:class="{ answerVisited: answer.visited }">
                    <div class="listAnswerTextContainer">
                        <h4 class="listAnswerText">{{ answer.content.subtitle }}</h4>
                    </div>
                    <a @click="expandAnswer(answer, comment, $event)" class="listLink"><span class="listLinkText">View</span></a>
                </div>
                <!-- Expanded view -->
                <div v-show="answer.showExpanded">
                    <CardContainer @collapseCard="hideAnswer(answer, comment, $event)" v-bind:answer="answer"/>
                    <div class="listBtnContainer">
                        <!-- Feedback Buttons for the selected answer -->
                        <Feedback v-bind:data="{answer: answer, isListAnswer: true}"/>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
import Vue from "vue";

import CardContainer from "./CardContainer.vue";
import Feedback from './Feedback.vue';

export default {
    name: "ListContainer",
    props: ["comment"],
    components: {
        CardContainer,
        Feedback
    },
    data() {
        return {
            maxListSize: 4
        };
    },
    methods: {
        scrollToChatRow(el) {
            let chatRow = this.findAncestor(el, 'chatRowAva');
            chatRow.scrollTop = 0;
        },
        enableListScroll(length) {
            return {
                'listScroll' : length > this.maxListSize
            }
        },
        expandAnswer(answer, comment, event) {
            answer.visited = true; 

            comment.answerList.forEach( (item) => {
                if(item.id !== answer.id) {
                    item.hidden = true;
                }
            });

            let scrollDiv = this.findAncestor(event.target, 'list');
            scrollDiv.classList.remove('listScroll');
            answer.showExpanded = !answer.showExpanded;

            this.scrollToChatRow(event.target);
            this.$store.dispatch("setIdleTimeOutTimer");
        },
        hideAnswer(answer, comment, event) {
            comment.answerList.forEach( (item) => {
                item.hidden = false;
            });

            let scrollDiv = this.findAncestor(event.target, 'list');

            if(comment.answerList.length > this.maxListSize) {
                scrollDiv.classList.add('listScroll');
            }

            answer.showExpanded = !answer.showExpanded;

            this.scrollToChatRow(event.target);
            this.$store.dispatch("setIdleTimeOutTimer");
        },
        findAncestor(el, cls) {
            while ((el = el.parentNode) && !el.classList.contains(cls));
            return el;
        }
    }   
}
</script>

<style scoped>
.listScroll {
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.listScroll > :last-child {
  margin-bottom: 0px;
}

.listAnswerContent {
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
  background-color: #3a3c3e;
  padding-right: 5px;
  margin-right: 8px;
  margin-bottom: 10px;
}

.answerVisited {
  background-color: #334b6b;
}

.listAnswerTextContainer {
  margin-right: 10px;
  padding-left: 10px;
}

.listAnswerText {
    max-width: 22.5em;
}

.listLink {
    display:flex;
    align-items:center;
    justify-content:center;
    font-weight: 400;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: 0em 1em;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 10px;
    color: #fff;
    background-color:#2e4c30;
    text-decoration: none;
    cursor: pointer;
    margin-right: -5px;
}

.listLinkText {
    vertical-align: -webkit-baseline-middle;
}

.listReturnBtn {
    margin-top: -2px;
    padding: .2rem .2rem;
}

.listBtnContainer {
  display: flex;
}

.returnBtnContainer {
  padding-top: 10px;
}
</style>
